/*!
 * Copyright © 2025 Actavivo
 */
import * as AV from "./Interfaces/AV.Interfaces";
import { Server } from "../Platform/Server";
import { AVEntity } from "./AVEntity";

export class Event extends AVEntity {
	static _eventBaseApi = "/api/Event";

	public static async addParticipants(source: AV.IFK, target: AV.IContact[]): Promise<AV.IEvent> {
		return await Server.post(this._eventBaseApi + "/AddParticipant", {
			source: source,
			target: target,
			type: "Participant",
		});
	}
	public static async addParticipant(source: AV.IFK, target: AV.IContact, occurId: any): Promise<AV.IEvent> {
		return await Server.post(this._eventBaseApi + "/AddParticipant", {
			source: source,
			target: [target],
			type: "Participant",
			occurId: occurId
		});
	}
	public static async removeParticipant(source: AV.IFK, target: AV.IContact, occurId: string): Promise<AV.IEvent> {
		return await Server.post(this._eventBaseApi + "/RemoveParticipant", {
			source: source,
			target: target,
			occurId: occurId,
			type: "Participant",
		});
	}
	public static async updateParticipant(source: AV.IFK, target: AV.IParticipantLink, occurId: string): Promise<AV.IEvent> {
		return await Server.post( this._eventBaseApi + "/UpdateParticipant", { source: source, target: target, occurId: occurId });
	}
	public static async cancelEvent(Source: AV.IFK): Promise<AV.IEvent> {
		return await Server.post(this._eventBaseApi + "/Cancel", Source);
	}
	public static async unCancelEvent ( Source : AV.IFK ) : Promise<AV.IEvent>
	{
		return await Server.post( this._eventBaseApi + "/UnCancel", Source );
	}
	public static async addResource(source: AV.IFK, target: AV.IEventResource, occurId: string): Promise<AV.IEvent> {
		return await Server.post(this._eventBaseApi + "/AddResource", { source: source, target: target, occurId: occurId });
	}
	public static async removeResource(source: AV.IFK, target: AV.IEventResource, occurId: string): Promise<AV.IEvent> {
		return await Server.post(this._eventBaseApi + "/RemoveResource", { source: source, target: target, occurId: occurId });
	}
	public static async updateResource(source: AV.IFK, target: AV.IEventResource, occurId: string): Promise<AV.IEvent> {
		return await Server.post( this._eventBaseApi + "/UpdateResource", { source: source, target: target, occurId: occurId });
	}
	public static async editSeriesEvents ( param : AV.IEventSeriesEdit)
	{
		return await Server.post( this._eventBaseApi + "/EditSeries", param);
	}
	public static async cancelSeries ( parent: AV.IFK, occurId: string )
	{
		return await Server.post( this._eventBaseApi + "/CancelSeries", { parent: parent, series: occurId })
	}
	public static async unCancelSeries ( parent : AV.IFK, occurId : string )
	{
		return await Server.post( this._eventBaseApi + "/UnCancelSeries", { parent: parent, series: occurId } )
	}
}
